import React from "react";
import "./experience.css";
import { FaStar } from "react-icons/fa";

export default function ExtaCurricular() {
  const extracurricular = [
    {
      title: 'Software Developer',
      company: 'The Robotics Forum',
      startDate: 'May 2020',
      endDate: 'August 2022',
      description: 'Worked as a trainee in a month long summer training workshop. Created a simple Quiz Website in HTML, CSS, PHP, JavaScript.Workedas amentor and teaching assistant where I taught React to 50+ students.'
    },
    {
      title: 'Volunteer',
      company: 'We Counseling',
      startDate: 'October 2021',
      endDate: 'December 2021',
      description: 'Voluntered to many students regarding education,career options,fields like art,sweing,fashion designing etc.'
    }
  ];
  
  return (
     <>
            <div className="">
              
                <div className="listexp">
                  <div className="image-text">
                    <div className="img-icon">
                    <FaStar                        className="icons"
                        style={{ color: "hsl(45, 100%, 72%)" }}
                      />
                    </div>
                    <h3 >Open Source Contributor at Mifos Initiative</h3>
                  </div>
                  {extracurricular.map((extracurr, index) => (
                  <ol key={index} className="timeline-list">
                    <li className="timeline-item">
                      <h4 className="h4 timeline-item-title">
                        {extracurr.company}
                      </h4>
                      <span>
                        {extracurr.title} | {extracurr.startDate} -{" "}
                        {extracurr.endDate}
                      </span>
                      <p className="timeline-text">- {extracurr.description}</p>
                    </li>
                  </ol>
                   ))}
                </div>
             
            </div>
          
          
        </>
  );
}